import { PSLHelper } from '@digitalworkflow/dwtranslateclient';
import { portalInfo } from '../config/constants/portalInfo';
import { AuthService } from '@digitalworkflow/dwloginclient';

const authService = AuthService.instance();

export const redirectToLogin = () => {
  console.log('Redirecting to Login Portal');
  authService.authLogout();

  window.location.href =
    `${PSLHelper.LoginPortalUrl()}/login/${portalInfo.loginProfileId}?return=` +
    window.location.hostname;
};
